const MAX_DIM = 1600;
const QUALITY = 0.8;
const SKIP_BELOW = 300 * 1024;

const isCompressibleImage = (file) =>
  ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'].includes(file.type);

export const compressImage = (file) => new Promise((resolve) => {
  if (!isCompressibleImage(file) || file.size < SKIP_BELOW) { resolve(file); return; }
  const url = URL.createObjectURL(file);
  const img = new Image();
  img.onload = () => {
    URL.revokeObjectURL(url);
    const scale = Math.min(1, MAX_DIM / Math.max(img.width, img.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.width * scale);
    canvas.height = Math.round(img.height * scale);
    canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
    canvas.toBlob((blob) => {
      if (blob && blob.size < file.size) {
        const name = file.name.replace(/\.(png|webp|heic|heif)$/i, '.jpg');
        resolve(new File([blob], name, { type: 'image/jpeg' }));
      } else resolve(file);
    }, 'image/jpeg', QUALITY);
  };
  img.onerror = () => { URL.revokeObjectURL(url); resolve(file); };
  img.src = url;
});

export const prepareFiles = async (fileList) =>
  Promise.all(Array.from(fileList).map((f) => compressImage(f)));
